"use strict";
/*
 * Copyright (C) 2023 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = void 0;
/** Frame animation direction. */
var Direction;
(function (Direction) {
    /** Normal animation direction. */
    Direction["Forward"] = "forward";
    /** Reversed animation direction. */
    Direction["Reverse"] = "reverse";
    /** Animation is played forward and then backward and so on. */
    Direction["PingPong"] = "pingpong";
})(Direction || (exports.Direction = Direction = {}));
//# sourceMappingURL=Direction.js.map